import type { DyCartEventDetail } from './types';

/**
 * @name dispatchDyAddToCart
 * @description Вызывает событие DY:add_to_cart для DynamicYields
 * @param detail:{id: number | string; quantity: number; productPrice: number;}
 */
export const dispatchDyAddToCart = (detail: DyCartEventDetail) => {
  document.body.dispatchEvent(new CustomEvent('DY:add_to_cart', { detail }));
};

/**
 * @name dispatchDyRemoveFromCart
 * @description Вызывает событие DY:remove_from_cart для DynamicYields
 * @param detail:{id: number | string; quantity: number; productPrice: number;}
 */
export const dispatchDyRemoveFromCart = (detail: DyCartEventDetail) => {
  document.body.dispatchEvent(new CustomEvent('DY:remove_from_cart', { detail }));
};

/**
 * @name dispatchDyFilter
 * @description Вызывает событие DY:filter_items для DynamicYields
 * @param detail: DyFilterEventDetail
 */
export function gfLoaded(): Promise<boolean> {
  const max = 10;
  let attempt = 1;
  let interval: NodeJS.Timeout;
  return new Promise((resolve, reject) => {
    interval = setInterval(() => {
      if ('gf_campaign' in window) {
        clearInterval(interval);
        resolve(true);
      } else if (attempt === max) {
        clearInterval(interval);
        reject(new Error('GF campaign not found'));
      }

      attempt += 1;
    }, 1000);
  });
}
